import React from "react";

export const Row = ({ gutter, className = "", children, style }) => {
  const gap = Array.isArray(gutter) ? gutter[0] : gutter || 0;
  return (
    <div
      className={`row ${className}`}
      style={{ gap: gap ? `${gap}px` : undefined, ...style }}
    >
      {children}
    </div>
  );
};

export const Col = ({
  span,
  xs,
  sm,
  md,
  lg,
  xl,
  className = "",
  children,
  style,
}) => {
  const classes = [
    "col",
    span && `col-${span}`,
    xs && `col-xs-${xs}`,
    sm && `col-sm-${sm}`,
    md && `col-md-${md}`,
    lg && `col-lg-${lg}`,
    xl && `col-xl-${xl}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
};
